import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useState } from "react";
import Newlogo from "../resources/Logo.svg";
import hamberger from "../resources/hambarger.svg";
import Callsupport from "../resources/callsupport.svg";
import Callback from "../resources/callbacksupport.svg";
import Whatupsupport from "../resources/whatupsupport.svg";
import Mailsupport from "../resources/mailsupport.svg";
import Footerlogo from "../resources/pollicydekhoo-Cdr-jpg-300x300 1 (1).png";
import cross from "../resources/cross.svg";
import { Modal, Box, Typography, Button, TextField } from "@mui/material";

function Clamin() {
  const navigate = useNavigate();


  const [toogle, settoggle] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  };


  const[Claimtype,setClaimtype] = useState({clam_informationcol:""})
  


  return (
    <div className="backcolou">
      <div className="container-fluid d-none d-lg-block">
        <div className="row">
          <div className="col-sm-8 ps-5 text-start mt-4 mb-3">
            <select name="" id="" className="lang">
              <option value="">English</option>
              <option value="">Hindi</option>
            </select>
          </div>
          <div className="col-sm-2 mt-4">
            <div>
              <span>+917734007799</span>
            </div>
          </div>
          <div className="col-sm-2 mt-4 text-start">
            <div className="">info@policydekhoo.com</div>
          </div>
        </div>
      </div>
      {toogle === false ? (
        <>
          <div className="container-fluid mb-5 ">
            <div className="row align-items-center">
              {/* Logo Section */}
              <div
                className="col-8 col-lg-3 mt-3 ps-5 d-flex align-items-center"
                onClick={() => navigate("/")}
              >
                <img
                  src={Newlogo}
                  alt="Logo"
                  style={{ width: "12vw", maxWidth: "50px", cursor: "pointer" }}
                />
                <span className="fs-5 ms-2">Policy Dekhoo</span>
              </div>

              {/* Navigation Links */}
              <div className="col-lg-7 col-4 d-flex justify-content-end align-items-center">
                <div className="row align-items-center w-100">
                  {/* Desktop Menu */}
                  <div className="col-lg-9 d-none d-lg-block">
                    <ul className="list-inline mb-0">
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/")}
                      >
                        Home
                      </li>
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                      >
                        PD Advantages
                      </li>
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                      >
                        Customer Rating
                      </li>
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/About")}
                      >
                        About Us
                      </li>
                      <li className="list-inline-item dropdown p-1 fs-6">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          id="navbarDropdown"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{ cursor: "pointer" }}
                        >
                          Support
                        </a>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="navbarDropdown"
                          style={{ minWidth: "200px" }}
                        >
                          <li>
                            <a className="dropdown-item" href="#">
                              <img src={Callsupport} className="me-2" alt="" />
                              Call Us
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="mailto:info@policydekhoo.com"
                            >
                              <img
                                src={Mailsupport}
                                className="me-2"
                                alt="Mail Support"
                              />
                              Mail Us
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://wa.me/lokesh"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={Whatupsupport}
                                className="me-2"
                                alt="WhatsApp Support"
                              />
                              WhatsApp
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpen();
                              }}
                            >
                              <img
                                src={Callback}
                                className="me-2"
                                alt="Callback Icon"
                              />
                              Call Back
                            </a>
                          </li>

                          {/* Modal */}
                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box sx={style}>
                              {/* Modal Content */}
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                              >
                                Request a Call Back
                              </Typography>
                              <Box
                                component="form"
                                sx={{
                                  mt: 2,
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 2,
                                }}
                              >
                                {/* Phone Number Input */}
                                <TextField
                                  id="phone-number"
                                  label="Phone Number"
                                  variant="outlined"
                                  fullWidth
                                />

                                {/* Reason Textarea */}
                                <TextField
                                  id="reason"
                                  label="Reason"
                                  variant="outlined"
                                  fullWidth
                                  multiline
                                  rows={4}
                                />

                                {/* Buttons */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 1,
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                      // Add your submission logic here
                                      handleClose();
                                    }}
                                  >
                                    Request Call
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleClose}
                                  >
                                    Close
                                  </Button>
                                </Box>
                              </Box>
                            </Box>
                          </Modal>
                        </ul>
                      </li>
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/Claim")}
                      >
                        Claim
                      </li>
                    </ul>
                  </div>

                  {/* Mobile Menu */}
                  <div className="col-lg-3 col-4 d-lg-none text-end">
                    <img
                      src={hamberger}
                      alt="Menu"
                      style={{
                        cursor: "pointer",
                        width: "30px",
                        height: "30px",
                      }}
                      onClick={() => settoggle(!toogle)}
                    />
                  </div>
                </div>
              </div>

              {/* Contact Section */}
              <div className="col-lg-2 d-none d-lg-flex  justify-content-end pe-5">
                <span
                  className="fs-6 fw-bold "
                  style={{
                    cursor: "pointer",
                    borderBottom: "2px solid black", // Adjust thickness and color as needed
                    // paddingBottom: "4px",
                  }}
                >
                  Contact
                </span>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {toogle === true ? (
        <>
          <div className="container menuu">
            <div className="row mt-5">
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-8  text-start ps-5">
                    <span className="fs-3">Policy dekhoo</span>
                  </div>
                  <div className="col-4">
                    <img
                      src={cross}
                      alt=""
                      onClick={(e) => settoggle(!toogle)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-7 col-1">
                <ul
                  className=""
                  style={{ listStyle: "none", textAlign: "left" }}
                >
                  <li
                    className=" p-2  fs-6"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/")}
                  >
                    Home
                  </li>
                  <li className=" p-2 fs-6" style={{ cursor: "pointer" }}>
                    PD Advantages
                  </li>
                  <li className="p-2 fs-6" style={{ cursor: "pointer" }}>
                    Customer Rating
                  </li>
                  <li
                    className=" p-2 fs-6"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/About")}
                  >
                    About Us
                  </li>
                  <li className="list-inline-item dropdown p-1 fs-6">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                    >
                      Support
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                      style={{ minWidth: "200px" }}
                    >
                      <li>
                        <a className="dropdown-item" href="#">
                          <img src={Callsupport} className="me-2" alt="" />
                          Call Us
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="mailto:info@policydekhoo.com"
                        >
                          <img
                            src={Mailsupport}
                            className="me-2"
                            alt="Mail Support"
                          />
                          Mail Us
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://wa.me/lokesh"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={Whatupsupport}
                            className="me-2"
                            alt="WhatsApp Support"
                          />
                          WhatsApp
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleOpen();
                          }}
                        >
                          <img
                            src={Callback}
                            className="me-2"
                            alt="Callback Icon"
                          />
                          Call Back
                        </a>
                      </li>

                      {/* Modal */}
                      <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          {/* Modal Content */}
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                          >
                            Request a Call Back
                          </Typography>
                          <Box
                            component="form"
                            sx={{
                              mt: 2,
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            {/* Phone Number Input */}
                            <TextField
                              id="phone-number"
                              label="Phone Number"
                              variant="outlined"
                              fullWidth
                              // onKeyPress={handleNumericOnly}
                              maxLength={10}
                            />

                            {/* Reason Textarea */}
                            <TextField
                              id="reason"
                              label="Reason"
                              variant="outlined"
                              fullWidth
                              multiline
                              rows={4}
                            />

                            {/* Buttons */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 1,
                              }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  // Add your submission logic here
                                  handleClose();
                                }}
                              >
                                Request Call
                              </Button>
                              <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleClose}
                              >
                                Close
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Modal>
                    </ul>
                  </li>
                  <li
                    className="p-2 fs-6"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/Claim")}
                  >
                    Claim
                  </li>
                </ul>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-12">
                <span className="get p-2">Contact Us</span>
              </div>
            </div>

            <div className="row fixed-bottom ">
              <div className="col-12">
                <div className=" ">
                  <span>© 2020 Policy Dekhoo | Powered by Policy Dekhoo</span>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {toogle === false ? (
        <>
          <div className="container my-5">
            <div
              className="card shadow border-0 mx-auto "
              style={{
                maxWidth: "800px",
                backgroundColor: "#F1F5F9",
                borderRadius: "15px",
                boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.2)",
              }}
            >
              <div className="card-body text-center">
                <h4 className="fw-bold mb-4">Claim</h4>
                <div className="row justify-content-center">
                  {/* Motor Insurance */}
                  <div className="col-6 col-sm-3 mb-3">
                    <div
                      className="p-3 rounded pol"
                      style={{
                        // backgroundColor: "#1f2a44",
                        color: "#fff",
                        display: "inline-block",
                      }}
                      onClick={() => navigate("Clam",{state:"Moter Insurance"})}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mt-2 insure"
                        viewBox="0 0 65.22 51.15"
                      >
                        <g id="Layer_2" data-name="Layer 2">
                          <g id="Layer_1-2" data-name="Layer 1">
                            <path d="M5.7,17.41A3,3,0,0,0,3.6,17c-1,0-1.83-.24-1.95-1.36s0-2.11,1.23-2.49c1.41-.45,2.75-1.59,4.39-.21.47.4,1.07-.51,1.32-1.22A45.51,45.51,0,0,1,11.5,4.89,7.52,7.52,0,0,1,17.77.59C25.7-.43,33.62.27,41.54,0a44,44,0,0,1,8,.9c2.46.38,3.71,2.78,4.7,5,.91,2,1.56,4.08,2.45,6.07.23.53.37,1.71,1.67.69,1.13-.89,4,.3,4.81,1.26a2.14,2.14,0,0,1,.31,2.17,1.56,1.56,0,0,1-1.68,1,3.51,3.51,0,0,0-2.25.32c1.31,1.21,2.58,2.32,3.79,3.5a5.61,5.61,0,0,1,1.84,4.37c-.09,7.49,0,15,0,22.48a3.13,3.13,0,0,1-3.47,3.43c-1.74,0-3.49,0-5.23,0-2.5,0-3.78-1.15-3.64-3.61.09-1.66-.56-2-2-1.76-9.83,1.33-19.71.46-29.57.71-2.54.06-5-.77-7.47-.75-.94,0-1.35.13-1.39,1.22-.1,3.46-.94,4.19-4.43,4.2H3.53A3.13,3.13,0,0,1,.07,47.7c0-7.3.1-14.6-.07-21.9a7,7,0,0,1,2.51-5.63C3.49,19.25,4.55,18.4,5.7,17.41Zm-1,5.9L4,24c-1.24.17-.77,1.16-.78,1.82,0,4.38.92,8.7.81,13.11-.07,2.74.86,3.3,3.69,2.63A7.46,7.46,0,0,1,6.2,36.82c.1-2.67,1.16-3.28,3.71-2.32,3,1.16,6.07,2.63,9.39,2.67,8.85.1,17.7,0,26.55,0a6.85,6.85,0,0,0,2.28-.27c2.6-.92,5.27-1.64,7.84-2.69,1.87-.76,2.89.26,3,2.34a8.05,8.05,0,0,1-1.56,5.07c2.47.77,3.85-.2,3.88-3,0-2.45-.22-4.94.33-7.34A38.65,38.65,0,0,0,62.07,25a.94.94,0,0,0-.81-1.1l-.69-.59c0-.25,0-.58-.11-.73-1.71-1.78-4-2.92-5.27-5.19-.31-.58-.92-.35-1.4-.35q-21.16,0-42.33,0c-.78,0-1.49.13-1.77.79C9.05,19.3,7.58,19.89,6.58,21,5.91,21.7,4.61,22,4.68,23.31Zm27.84-9.37c6.52,0,13,0,19.55,0,1.24,0,2-.28,1.43-1.58A31.33,31.33,0,0,0,50.32,5.6c-.53-.73-1.08-1.8-2.28-1.74-3.1.14-6.14-.55-9.22-.68a170.05,170.05,0,0,0-21.41.63A2.65,2.65,0,0,0,15.54,4.9c-2,2.19-2.75,5-3.82,7.66-.54,1.34.43,1.39,1.44,1.39C19.61,13.93,26.07,13.94,32.52,13.94ZM9.46,38a6.3,6.3,0,0,0,5.07,4.55c3,.36,6,.65,9,.75a199,199,0,0,0,26.63-.64c2.12-.21,3.58-1.67,4.86-3.26a1.18,1.18,0,0,0,0-1.08c-.33-.47-.6.15-.89.2-2.3.39-4.33,1.79-6.73,1.79H17.62a5.83,5.83,0,0,1-2.21-.43C13.54,39.08,11.55,38.61,9.46,38ZM3.4,44.44c-.77,3.62-.77,3.62,2.76,3.62.64,0,1.29,0,1.93,0s1.3.24,1.25-.71c0-.68.29-1.33-.79-1.85C6.87,44.69,5,45.43,3.4,44.44ZM59,48.06h.78c2.39,0,2.84-.57,2.31-3-.07-.29-.17-.86-.47-.66-1.53,1-3.38.22-5,1.07-1,.5-.65,1.09-.72,1.71-.1.92.58.82,1.16.83Z" />
                            <path d="M61.26,23.9c-.21,1.47.53,3-.55,4.44-.7.95-1.64,1.48-2.42,1C56.37,28.24,54.15,29,52.23,28a17.08,17.08,0,0,1-2.3-1.38,4.82,4.82,0,0,1,2.63-1.88c2.65-.64,5.23-1.57,8-1.42Z" />
                            <path d="M4.68,23.31c3.81.24,7.61.52,11,3.24-1.94,1.16-3.61,2.16-5.71,2A3.53,3.53,0,0,0,8.08,29C5.82,30.13,4,29,3.93,26.51c0-.84,0-1.68,0-2.51Z" />
                            <path d="M46.83,27.68c-.29.74-.93.82-1.59.83-2.19,0-4.39.17-6.58.12a7.44,7.44,0,0,0-5.21,1.86c-.67.58-1,.57-1.67,0a7.44,7.44,0,0,0-5.22-1.84c-2.19.05-4.38-.07-6.57-.12-.67,0-1.52-.09-1.52-.84s.9-.43,1.42-.53c6.49-1.29,13.06-.6,19.6-.79,2.29-.06,4.38,1,6.65.84A.56.56,0,0,1,46.83,27.68Z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <p className="mt-2">Motor Insurance</p>
                  </div>

                  {/* Health Insurance */}
                  <div className="col-6 col-sm-3 mb-3">
                    <div
                      className="p-3 rounded pol"
                      style={{
                        // backgroundColor: "#fff",
                        color: "#000",
                        display: "inline-block",
                      }}
                      onClick={() => navigate("Clam",{state:"Health Insurance"})}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mt-2 insure"
                        viewBox="0 0 57.42 50.51"
                      >
                        <g id="Layer_2" data-name="Layer 2">
                          <g id="Layer_1-2" data-name="Layer 1">
                            <path d="M57.42,20.12c-1.08.77-.69,2.1-1,3.11a28.87,28.87,0,0,1-7.16,11.63,72.92,72.92,0,0,1-12.7,10,55.19,55.19,0,0,0-6.13,4.65c-1.47,1.3-1.86,1.28-3.34,0-3.16-2.67-6.65-4.87-10-7.26C12,38.66,7.19,34.57,3.72,29.2A13.32,13.32,0,0,1,3,27.73a3,3,0,0,1,3.73,1.43A41,41,0,0,0,17,39.19c3.22,2.36,6.55,4.55,9.77,6.9.68.5,1.11,1.56,2,1.48s1.36-1,2.05-1.53c5-3.65,10.25-6.83,14.79-11a30.89,30.89,0,0,0,7.48-9.88,19.46,19.46,0,0,0,1.53-5.05A20.06,20.06,0,0,0,55.11,16,14.22,14.22,0,0,0,46.28,3.4c-6-2.35-11.71-.44-15.76,4.29-.18.21-.37.4-.55.6-1.16,1.32-1.32,1.3-2.48,0-1.82-2-3.63-4-6.32-4.93a13.23,13.23,0,0,0-7.83-.63A13.82,13.82,0,0,0,5,8.21,14.46,14.46,0,0,0,2.42,18.3a1.75,1.75,0,0,0,.17.68c.28.52.57,1.22.09,1.54a2.78,2.78,0,0,1-1.8.11C.3,20.53.17,20,.12,19.41-.46,13.29,1,7.91,5.85,3.8A15.57,15.57,0,0,1,12.21.56C18.42-1,23.59.73,27.93,5.25c.67.7,1,.66,1.62,0A14.76,14.76,0,0,1,35.94.85,15.85,15.85,0,0,1,45,.5a16,16,0,0,1,8.55,5.27,14.1,14.1,0,0,1,3.31,6.47c.07.34.19.52.56.42Z" />
                            <path d="M19.81,16.56c-.52,2.72-.95,5.11-1.43,7.48-.34,1.65-.73,3.29-1.14,4.93A1.16,1.16,0,0,1,15,29.1a46.8,46.8,0,0,1-1.72-4.53,9.13,9.13,0,0,0-.88-1.69l-.9,1.59a1.53,1.53,0,0,1-1.5.82c-2.43,0-4.87,0-7.31,0-.8,0-1.46-.22-1.47-1.12S2,23,2.81,23c1.77,0,3.54-.09,5.3,0a2,2,0,0,0,2.27-1.47,11.12,11.12,0,0,1,1.12-2.2c.31-.49.56-1,1.24-.94s.87.52,1.15,1.06c.71,1.39.91,3,1.95,4.4a9.7,9.7,0,0,0,.71-3.1c.4-2.36,1.07-4.66,1.38-7A35.3,35.3,0,0,1,19,8.93a1.09,1.09,0,0,1,1.15-.85,1.07,1.07,0,0,1,1,.8q.66,2.88,1.17,5.79c.5,2.87,1.07,5.72,1.56,8.58a23.76,23.76,0,0,1,.8,5c0,.27-.05.69.3.7a.82.82,0,0,0,.77-.52l2.91-7.77c.05-.13,0-.33.08-.41.59-.6.42-1.86,1.66-1.87s1.25,1.12,1.54,1.77c.8,1.8,1.36,3.71,2,5.57.14,0,.29,0,.31-.07,1-2.48,3-3,5.43-2.74,1.35.12,2.78.44,4.06-.9.62-.66,2-.35,2.77.75a2,2,0,0,1,.12,2.53c-.71,1.15-2.06,1.63-2.85.91-1.13-1-2.25-.95-3.48-.95-3.09,0-3.1,0-4.65,2.64-.1.16-.08.42-.2.53-.58.48-.73,1.49-1.75,1.4s-1-.89-1.26-1.51c-.53-1.27-1-2.56-1.48-3.86-.13-.37-.15-.79-.64-.81s-.43.5-.55.82c-1.33,3.4-2.67,6.79-4,10.18-.23.57-.58,1-1.25.91s-.94-.58-1.09-1.25c-.69-3.22-1.21-6.46-1.76-9.7-.36-2.08-.9-4.13-1.1-6.24C20.63,17.79,20.2,17.38,19.81,16.56Z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <p className="mt-2">Health Insurance</p>
                  </div>

                  {/* Life Insurance */}
                  <div className="col-6 col-sm-3 mb-3">
                    <div
                      className="p-3 rounded pol"
                      style={{
                        // backgroundColor: "#fff",
                        color: "#000",
                        display: "inline-block",
                      }}
                      onClick={() => navigate("Clam",{state:"Life Insurance"})}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="mt-2 insure"
                        viewBox="0 0 52.38 54.52"
                      >
                        <g id="Layer_2" data-name="Layer 2">
                          <g id="Layer_1-2" data-name="Layer 1">
                            <path d="M17.46,54.52c.05-.46-.3-.44-.6-.55-2.59-.85-5-4.11-4.86-6.75,0-.76.21-1.37,1.07-1.39s1.06.59,1.13,1.35a5.66,5.66,0,0,0,5.47,5.14A5.4,5.4,0,0,0,25,47.39c.17-7.13.07-14.27.08-21.4,0-.74-.16-.75-.94-.57a9,9,0,0,0-5.06,3.31c-.83,1-1.35,1-2.24-.08a8.92,8.92,0,0,0-7.75-3.54,9.64,9.64,0,0,0-6.84,3.46c-.43.51-.8,1-1.51.81S0,28.38,0,27.69A22.25,22.25,0,0,1,10.19,9.11,25.86,25.86,0,0,1,21.06,4.79a19.71,19.71,0,0,1,3.32-.42c.66,0,.74-.34.72-.86,0-.72,0-1.45,0-2.18S25.34,0,26.22,0s1.06.54,1.05,1.28,0,1.45,0,2.18.26.87.94.92c7.9.56,14.58,3.66,19.59,9.9a19.5,19.5,0,0,1,3.55,7,22.8,22.8,0,0,1,1,6.6c0,.65-.16,1.19-.73,1.45s-1-.13-1.43-.51A14,14,0,0,0,44,25.21a8,8,0,0,0-5.79,1.13,8.19,8.19,0,0,0-2.7,2.41,1.21,1.21,0,0,1-2.19,0A9.46,9.46,0,0,0,28,25.32c-.74-.2-.68.12-.69.51,0,.86,0,1.73,0,2.59,0,6.23-.07,12.45,0,18.67,0,2.95-2.6,6.29-5,6.91-.31.08-.5.18-.46.52ZM2.78,25.11A11.32,11.32,0,0,1,7.68,23a10.89,10.89,0,0,1,9.4,2.72c.74.69,1.2.59,1.87,0A10.31,10.31,0,0,1,24.42,23a10.75,10.75,0,0,1,9.11,2.79c.75.67,1.12.46,1.75-.06a10.86,10.86,0,0,1,6.41-2.8,10.24,10.24,0,0,1,7,2c.56.42,1,.4,1-.52a8.8,8.8,0,0,0-.52-1.79,16.49,16.49,0,0,0-3.31-6.91c-4.57-6-11-8.47-18.21-9.07a28.24,28.24,0,0,0-5.79.38,23.21,23.21,0,0,0-8.07,2.53A20.64,20.64,0,0,0,4.08,19.75,10.91,10.91,0,0,0,2.78,25.11Z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <p className="mt-2">Life Insurance</p>
                  </div>

                  {/* Other */}
                  <div className="col-6 col-sm-3 mb-3">
                    <div
                      className="p-3 rounded pol "
                      style={{
                        // backgroundColor: "#fff",
                        color: "#000",
                        display: "inline-block",
                      }}
                      onClick={() => navigate("Clam",{state:"Other"})}
                    >
                      <svg
                        width="43"
                        height="49"
                        viewBox="0 0 43 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M27.3882 11.4458H35.0732C35.6455 11.4458 36.136 10.9553 36.136 10.383C36.136 10.1377 36.0543 9.89246 35.8908 9.64719L26.2436 0.245267C25.9983 0.0817552 25.753 0 25.5078 0C24.9355 0 24.4449 0.490535 24.4449 1.06283V8.58437C24.5267 10.1377 25.8348 11.4458 27.3882 11.4458Z"
                          fill="black"
                        />
                        <path
                          d="M12.7539 36.7901C12.7539 33.9287 14.389 31.3943 17.0052 30.4132C19.1309 29.5956 21.2565 29.1051 23.5457 29.1051C26.8159 29.1051 29.5956 30.0044 32.1301 30.7402C33.5199 31.149 34.828 31.5578 36.0543 31.803L36.2179 17.087C36.2179 16.3512 35.5638 15.6971 34.828 15.6971H24.5268C22.0741 15.6971 20.2755 13.735 20.2755 11.4458V1.38985C20.2755 0.654048 19.6214 0 18.8039 0H4.25131C1.88039 0 0 1.96214 0 4.25131V38.5888C0 40.9597 1.96214 42.8401 4.25131 42.8401H12.7539V36.7901Z"
                          fill="black"
                        />
                        <path
                          d="M40.3873 36.7083C32.9475 38.9975 27.0611 31.9665 18.9673 35.3185C18.3132 35.5638 17.9862 36.136 17.9862 36.7901V45.2927C17.9862 46.4373 18.9673 47.0913 19.9483 46.7643C28.0422 44.3116 33.8468 51.3426 41.4501 48.1542C42.0224 47.9089 42.513 47.3366 42.513 46.6826V38.2617C42.513 37.1989 41.4501 36.4631 40.3873 36.7083ZM30.4949 44.6387C28.778 44.6387 27.3064 43.2488 27.3064 41.4502C27.3064 39.7333 28.6962 38.2617 30.4949 38.2617C32.2935 38.2617 33.6833 39.6515 33.6833 41.4502C33.6833 43.2488 32.2935 44.6387 30.4949 44.6387Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <p className="mt-2">Other</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <footer className="container-fluid backgroundtheme mt-5 ">
            <div className="row p-5">
              {/* Logo Section */}
              <div className="col-md-7 text-center text-md-start mb-4 mb-md-0">
                <div className="mb-3">
                  <img
                    src={Footerlogo}
                    alt="Footer Logo"
                    style={{ maxWidth: "8vw" }}
                    className="footerlog"
                  />
                </div>
                <div className=" justify-content-center align-items-center w-50 d-none d-sm-block">
                  <span className="text-white">
                    Trust us for peace of mind and reliable protection, backed
                    by our unwavering commitment to your satisfaction and
                    security.
                  </span>
                </div>
                <div className=" justify-content-center align-items-center d-block d-sm-none">
                  <span className="text-white">
                    Trust us for peace of mind and reliable protection, backed
                    by our unwavering commitment to your satisfaction and
                    security.
                  </span>
                </div>
              </div>

              {/* Navigation Links */}
              <div className="col-md-5 mt-4 	d-none d-sm-block">
                <div className="row">
                  {/* First Column */}
                  <div className="col-sm-6 text-center text-sm-start mb-4 mb-sm-0">
                    <ul className="list-unstyled ">
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        Home
                      </li>
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        PD Advantages
                      </li>
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        Customer Rating
                      </li>
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        About Us
                      </li>
                    </ul>
                  </div>

                  {/* Second Column */}
                  <div className="col-sm-6 text-center text-sm-start">
                    <ul className="list-unstyled ">
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        Support
                      </li>
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        Claim
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </footer>

          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div>
                  <a
                    href="https://unairesync.com/"
                    style={{ color: "black", textDecoration: "none" }}
                    className="fs-6 "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    All Rights Reserved | Developed By UnaireSync
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default Clamin;
